import React, { useState, useEffect, useContext } from 'react';
import { Context as AuthContext } from '../context/AuthContext';
import dmsLogo from '../assets/logos/DMSLogo.svg';
import history from '../history';

const Landing = () => {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const { tryLocalSignin, signin, state, clearErrorMessage } =
    useContext(AuthContext);
  const { errorTitle, errorMessage } = state;

  useEffect(() => {
    tryLocalSignin();
  }, []);

  const loginFunction = (e) => {
    signin({ email, password });
  };

  return (
    <div className='static'>
      <a
        className='absolute bottom-16 right-16 h-40 w-96 bg-contain bg-bottom bg-no-repeat md:mr-5'
        style={{ backgroundImage: `URL(${dmsLogo})` }}
        href='https://dms.academy/'
        target='_blank'
        rel='noreferrer'
        aria-label='DMS Academy'
      />
      <div className='flex flex-col justify-between p-6 md:mt-16 md:mx-auto md:p-0 md:h-auto md:max-w-3xl h-window bg-white relative md:top-1/4 overflow-y-auto md:overflow-y-hidden overflow-x-hidden z-20'>
        <div className='divide-y-2 divide-black divide-opacity-50'>
          <div className='text-3xl text-dms-primary font-semibold my-4'>
            Welcome to DMS Sims
          </div>
          <div className='pl-1'>
            {errorMessage && (
              <div className='bg-red-100 border-solid border-t-2 border-b-2 border-red-700 mt-4 p-4'>
                <h3 className='text-red-700 p-0 text-base'>{errorTitle}</h3>
                <p
                  className='text-sm font-normal text-red-700 p-0 pt-2'
                  dangerouslySetInnerHTML={{ __html: errorMessage }}
                />
              </div>
            )}

            <div className='flex flex-col items-start h-auto w-96 mt-6'>
              <label className='font-semibold mb-2 block z-10 whitespace-nowrap w-full'>
                Email
                <input
                  className='block w-full border-gray-300 rounded mt-2 mb-4'
                  type='email'
                  placeholder=''
                  value={email}
                  name='email'
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>
            </div>
            <div className='col-span-1 flex flex-col flex-1'>
              <form className='relative'>
                {!showPassword ? (
                  <svg
                    fill='none'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    className='absolute left-2 bottom-0 transform -translate-y-6 text-gray-400'
                    onClick={(e) => setShowPassword(!showPassword)}
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'
                    />
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'
                    />
                  </svg>
                ) : (
                  <svg
                    fill='none'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    className='absolute left-2 bottom-0 transform -translate-y-6 text-gray-400'
                    onClick={(e) => setShowPassword(!showPassword)}
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21'
                    />
                  </svg>
                )}
                <label className='font-semibold mb-1 mr-1 block z-10 whitespace-nowrap w-96'>
                  Password
                  <input
                    className='block w-full border-gray-300 rounded mt-2 mb-4 pl-10'
                    type={!showPassword ? 'password' : 'text'}
                    placeholder=''
                    value={password}
                    name='password'
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete='new-password'
                  />
                </label>
              </form>
              <a
                className='mt-14 text-dms-primary font-bold hover:cursor-pointer hover:underline'
                href='/forgot_password'
              >
                Forgot password?
              </a>
            </div>
          </div>
        </div>
        <div className='flex flex-row items-start md:items-end flex-wrap'>
          <button
            className={`w-40 mr-4 my-6 py-2 px-4 hover border-2 hover:text-dms-primary hover:border-2 hover:border-dms-primary hover:bg-white text-lg font-medium cursor-pointer transition duration-100 rounded-md z-10 bg-dms-primary text-white`}
            onClick={(e) => loginFunction()}
          >
            Log in
          </button>
          <button
            className={`my-6 py-2 px-4 hover border-2 hover:text-dms-primary hover:border-2 hover:border-dms-primary hover:bg-white text-lg font-medium cursor-pointer transition duration-100 rounded-md z-10 bg-dms-primary text-white`}
            onClick={() => {
              clearErrorMessage();
              history.push('/signup');
            }}
          >
            Create account
          </button>
        </div>
      </div>
    </div>
  );
};

export default Landing;
